var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('default-layout',[_c('div',[_c('el-button',{staticClass:"excel",attrs:{"type":"primary","size":"large","plain":""},on:{"click":_vm.download}},[_vm._v(" "+_vm._s(_vm.$t('commons.download_excel'))+" ")]),_c('BaseCurrencyInfo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }